module.exports = __webpack_public_path__ + "img/relatus_green_logo.f19b4398.svg";